// React 19 + antd 5: without this patch the static message / notification / Modal.confirm calls render nothing, so
// every portal toast ("The change is approved", save errors) was silently lost (launch QA, ANS-57).
import '@ant-design/v5-patch-for-react-19'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import 'antd/dist/reset.css'
import './index.css'
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
